import {ReactNode} from "react";

export const UNMASK_SELECTOR = "[data-unmask]";

/**
 * Session replays mask all text; text inside this wrapper is recorded as is, so it must never
 * contain client data.
 */
const Unmasked = ({children}: {children: ReactNode}) => (
  <span data-unmask="" style={{display: "contents"}}>
    {children}
  </span>
);

export default Unmasked;
